module.exports = __webpack_public_path__ + "static/media/icon_alert_big.bbfe4551.svg";